export default __webpack_public_path__ + "static/media/yx1-in-person.c3a0a8ca.png";